import { render, staticRenderFns } from "./OrderStatusLookup.vue?vue&type=template&id=5316227a&scoped=true&"
import script from "./OrderStatusLookup.vue?vue&type=script&lang=js&"
export * from "./OrderStatusLookup.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusLookup.vue?vue&type=style&index=0&id=5316227a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5316227a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VListItemContent,VListItemTitle,VSelect})
